import { gql } from "@apollo/client";

export const getTopLensesInfo = gql`
    query getTopLensesInfo(
        $limit: Int!
        $offset: Int!
        $filterBy: FilterBy
        $type: GetLensesType!
        $sortBy: SortBy!
        $sortDirection: MyLensesSortDirection!
    ) {
        lenses: getMyLensesLenses(
            input: {
                limit: $limit
                offset: $offset
                filterBy: $filterBy
                type: $type
                sortBy: $sortBy
                sortDirection: $sortDirection
            }
        ) {
            lensesList {
                id
                name
                iconUrl
                previewUrl
                unlockableId
                organizationId
                lensAccountId {
                    lensSpaceId
                }
            }
        }
    }
`;
